import { Box, Flex, FlexProps, Text } from '@chakra-ui/react'
import { PriceText } from '_app/components'
import { TrashIcon } from '_app/components/Icons'
import { Money } from '_app/types/api'

interface PriceRowProps extends FlexProps {
  text: string;
  amount: Money;
  onDelete?: () => void;
}

export const PriceRow = ({
  text,
  amount,
  onDelete,
  ...rest
}: PriceRowProps) => {
  return (
    <Flex {...rest}>
      <Box flex={1} minW={0}>
        <Text
          fontWeight={300}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {text}
        </Text>
      </Box>
      <Flex
        ml={{
          base: 5,
          md: 10,
          lg: '3.125rem',
        }}
      >
        {onDelete && (
          <Box role="button" onClick={onDelete} aria-label="usuń">
            <TrashIcon />
          </Box>
        )}
        <PriceText
          amount={amount}
          floating
          minimumFractionDigits={2}
          minW="6.25rem"
          textAlign="right"
        />
      </Flex>
    </Flex>
  )
}
